import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '../../common/toolTip';
import MembershipPackageAdd from './add';
import MembershipPackageDelete from './delete';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import axios from 'axios';
import { useUser } from '../../AdminUsers/UserContext';
const MembershipPackage = () => {
  const { checkPermission } = useUser();
  const [addPopupStatus, setAddPopupStatus] = useState(false);
  const [isSearchbar, toggleSearchBar] = useState(false);

  const [updateData, setUpdateData] = useState({});

  const [eventType, setEventType] = useState('');

  const handleAddPopup = async(status, type, data) => {
    setUpdateData(data);
    setEventType(type);
    if(type==="Add"){
      const hasPermission = await checkPermission("Package", "create");
      if (!hasPermission) return;
    }else{
      const hasPermission = await checkPermission("Package", "update");
      if (!hasPermission) return;
    }
    setAddPopupStatus(status);
    setViewPopupStatus(false);
  };

  const [viewPopupStatus, setViewPopupStatus] = useState(false);

  const handleViewPopup = (type, data) => {
    setUpdateData(data);
    setEventType(type);
    setViewPopupStatus(true);
  };

  const [deletePopupStatus, setDeletePopupStatus] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const handleDelete = async (id) => {
    setDeleteId(id);
  
    const hasPermission = await checkPermission("Package", "delete");
    if (!hasPermission) return;
  
    setDeletePopupStatus(true);
  };
  

  const handleCloseDelete = () => {
    setDeletePopupStatus(false);
    setViewPopupStatus(false);
  };

  const [membershipPackageData, setMembershipPackageData] = useState([]);

  const fetchMembershipPackageData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('access_token'),
        },
      });

      if (response.data.status) {
        const data = response.data.data.map((item) => ({
          ...item,
          id: item.id,
          name: item.application_name || "N/A",
          link: `${ROUTE_BASE_URL}/membership-application/${item.slug}` || "N/A",
          currency: item.currency_symbol ? `${item.currency_symbol} (${item.currency_code})` : "N/A",
          amount: item.fee || "N/A",
          gstValue: item.gst_value || "N/A",
        }));
        setMembershipPackageData(data);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

    // Check Admin User Permission
    const [checkUserLoading, setCheckUserLoading] = useState(false); 
    const fetchPermission = async () => {
      setCheckUserLoading(true);
      try {
        const hasPermission = await checkPermission("Package", "view");
        if (!hasPermission) return;
      } catch (error) {
        console.error("Error fetching super specialty data:", error);
      }finally{
        setCheckUserLoading(false);
      }
    };
    useEffect(() => {
      fetchPermission();
    }, []);

  useEffect(() => {
    fetchMembershipPackageData();
  }, []);

  return (
    <>
    {checkUserLoading? (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      ) : (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1>Membership Package</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                <li className="breadcrumb-item active" aria-current="page">
                  Membership Package
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs">
            {/* <span onClick={() => toggleSearchBar(true)} className="btn btn-outline-primary mr-1" title="">Add New</span> */}
            <span
              onClick={() => handleAddPopup(true, 'Add', {})}
              className="btn btn-outline-primary mr-1"
              title=""
            >
              Add New
            </span>
          </div>
        </div>
      </div>
      <div className="row clearfix hover_td_table">
        <div className="col-lg-12 col-md-12">
          <div className="table-responsive">
            <table className="table table-hover table-custom spacing5">
              <thead>
                <tr>
                  <th style={{ width: '20px' }}>S.NO</th>
                  <th>Application Name</th>
                  <th style={{ width: '50px' }}>Currency Type</th>
                  <th style={{ width: '50px' }}>Amount</th>
                  <th style={{ width: '50px' }}>GST</th>
                  <th style={{ width: '110px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {membershipPackageData.map((item, index) => (
                  <tr key={item.id}>
                    <td><span>{String(index + 1).padStart(2, '0')}</span></td>
                    <td>
                      <div className="d-flex align-items-center member-package-a">
                        <div className="ml-3">
                          <Tooltip text={`${item.name}`} id={`${item.name}`} />
                          <Link to={[5,6].includes(index+1) ? '#' : item.link}
                            data-for={`${item.name}`}
                            data-tip title="">
                            {item.name}
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>{item.currency}</td>
                    <td>{item.amount}</td>
                    <td>{item.gstValue}</td>
                    <td>
                      <Tooltip text="Edit" id={`edit-${item.id}`} />
                      <button
                        type="button"
                        onClick={() => handleAddPopup(true, 'Update', item)}
                        className="btn btn-sm btn-default edit_button_package"
                        title="Edit"
                        data-for={`edit-${item.id}`}
                        data-tip
                      >
                        <i className="fa fa-edit" />
                      </button>
                      <Tooltip text="Delete" id={`delete-${item.id}`} />
                      <button
                        type="button"
                        onClick={() => handleDelete(item.id)}
                        className="btn btn-sm btn-default delete_button_package"
                        title="Delete"
                        data-for={`delete-${item.id}`}
                        data-tip
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <MembershipPackageAdd
        fetchMembershipPackageData={fetchMembershipPackageData}
        addPopupStatus={addPopupStatus}
        handleAddPopup={handleAddPopup}
        eventType={eventType}
        updateData={updateData}
      />
      <MembershipPackageDelete fetchMembershipPackageData={fetchMembershipPackageData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete} />
    </div>)}
    </>
  );
};
export default MembershipPackage;
